import Text from "../../Components/Text"
import AdminController from "../../APIController/AdminController"
import React, { useState } from "react";
import Form from "../../Components/Form";
import TextInput from "../../Components/Form/TextInput";
import Checkbox from "../../Components/Form/Checkbox";

const AdminManagement = ({user, afterAction}) => {
    const [firstName, setFirstName] = useState(user.firstName)
    const [lastName, setLastName] = useState(user.lastName)
    const [isAdmin, setIsAdmin] = useState(user.role === "ADMIN")
    const {updateUser} = AdminController()

    const handleFormSubmit = async(e) =>{
        e.preventDefault()
        const userAdminDTO = {
            firstName: firstName,
            lastName: lastName,
            isAdmin: isAdmin
        }
        await updateUser(user.id, userAdminDTO)
        afterAction()
    }

    return(
        <Form onSubmitAction={handleFormSubmit} submitButtonText={"Usereinstellungen Speichern"}>
            <Text type="maintitle" classNames={"flex text-center justify-center"}>{`${user.firstName} ${user.lastName} bearbeiten`}</Text>
            <TextInput attribute={firstName} id={"firstName"} label={"Vorname"} placeholder={"Vorname"} action={(e) => setFirstName(e.target.value)} />
            <TextInput attribute={lastName} id={"lastName"} label={"Nachname"} placeholder={"Nachname"} action={(e) => setLastName(e.target.value)} />
            <Checkbox attribute={isAdmin} id={"isAdmin"} label={"Administrator?"} required={false} action={(e) => setIsAdmin(e.target.checked)} />
        </Form>
    )
}
export default AdminManagement